"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeToPhoneAuth = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const changeToPhoneAuth = exports.changeToPhoneAuth = (0, _actionGenerator.actionGenerator)(_types.EStateActionTypes.ChangeStateToPhoneAuth);